export type EmailGroup = {
  module: string;
  emails: EmailItem[];
};

export type EmailItem = {
  key: string;
  label: string;
};

export const emailsKeys: string[] = [
  'order_needs_special_attention',
  'order_inventory_returned_notification_admin',
  'admin_order_email',
  'offline_order',
  // TODO: Uncomment this when we migrate call-off/extend orders to v2
  // 'order_extension_calloff_request',
  'order_request_status_update_admin',
  'order_return_reminder_admin',
  'proof_insurance_request',
  'order_approved_email_admin',
  'order_start_reminder_admin',
  'renter_agreed_terms_successfully_admin',
  'onaccount_request',
  'new_registration_admin',
  'user_has_authenticated_card_payment_admin',
  'contact_us',
  'review_us',
  'admin__autopay_invoice_failure',
  'admin__daily_collectibles_update',
  'admin__daily_reports',
  'admin__charge_dispute',
  'admin__license_insurance_expiring',
  'admin__upcoming_work_order',
  'admin__seis_cert_error',
  'admin__invoice_copy',
  'admin__user_payment_banned_admin',
  'admin__security_deposit_extension_failed',
];

export const emailsGroup: EmailGroup[] = [
  {
    module: 'Orders',
    emails: [
      {
        key: 'order_needs_special_attention',
        label: 'Order Needs Special Attention',
      },
      {
        key: 'order_inventory_returned_notification_admin',
        label: 'Inventory Returned Notification',
      },
      {
        key: 'admin_order_email',
        label: 'Admin Order Email',
      },
      {
        key: 'offline_order',
        label: 'Offline Order',
      },
      // TODO: Uncomment this when we migrate call-off/extend orders to v2
      /* {
        key: 'order_extension_calloff_request',
        label: 'Extension/Callof Request',
      }, */
      {
        key: 'order_request_status_update_admin',
        label: 'Extension/Calloff Request Update',
      },
      {
        key: 'order_return_reminder_admin',
        label: 'Return Notification',
      },
      {
        key: 'proof_insurance_request',
        label: 'Proof of insurance upload request',
      },
      {
        key: 'order_approved_email_admin',
        label: 'Approved Notification',
      },
      {
        key: 'order_start_reminder_admin',
        label: 'Upcoming Order Reminder Notification',
      },
      {
        key: 'admin__autopay_invoice_failure',
        label: 'User Automatic Payment has Failed',
      },
      {
        key: 'admin__charge_dispute',
        label: 'Charge Dispute',
      },
      { key: 'admin__security_deposit_extension_failed', label: 'Security Deposit Extension Failed' },
      { key: 'admin__seis_cert_error', label: 'SEIS Rental Damage Waiver Insurance Errors' },
      { key: 'admin__invoice_copy', label: 'Invoice Copy' },
      { key: 'admin__user_payment_banned_admin', label: 'User Payment Banned' },
    ],
  },
  {
    module: 'Service & Repair',
    emails: [
      {
        key: 'admin__upcoming_work_order',
        label: 'Upcoming Work Order',
      },
    ],
  },
  {
    module: 'Renters',
    emails: [
      {
        key: 'renter_agreed_terms_successfully_admin',
        label: 'Renter Agreed Terms Successfully',
      },
      {
        key: 'onaccount_request',
        label: 'Rent on Account Request',
      },
      {
        key: 'admin__license_insurance_expiring',
        label: 'License/Insurance Expiring Warning',
      },
    ],
  },
  {
    module: 'Users',
    emails: [
      {
        key: 'new_registration_admin',
        label: 'New Registration',
      },
      {
        key: 'user_has_authenticated_card_payment_admin',
        label: 'User Has Authenticated Card/Payment',
      },
    ],
  },
  {
    module: 'Other',
    emails: [
      {
        key: 'contact_us',
        label: 'Contact Us',
      },
      {
        key: 'review_us',
        label: 'Feedback Form',
      },
      {
        key: 'admin__daily_collectibles_update',
        label: 'Daily Collectibles Update',
      },
      {
        key: 'admin__daily_reports',
        label: 'Daily Reports',
      },
    ],
  },
];
